import {
    SMS_SYSTEM_CREATE_EDIT_OPEN_MODAL,
    SMS_SYSTEM_CREATE_REQUEST,
    SMS_SYSTEM_CREATE_RESULT,
    SMS_SYSTEM_EDIT_REQUEST,
    SMS_SYSTEM_EDIT_RESULT,
    SMS_SYSTEM_GET_REQUEST,
    SMS_SYSTEM_GET_RESULT,
} from 'Redux/actionTypes';

export const smsSystemCreateEditOpenModal = (open, data) => ({
    type: SMS_SYSTEM_CREATE_EDIT_OPEN_MODAL,
    payload: { open, data }
})

export const smsSystemCreateRequest = (data) => ({
    type: SMS_SYSTEM_CREATE_REQUEST,
    payload: data
})

export const smsSystemCreateResult = (result) => ({
    type: SMS_SYSTEM_CREATE_RESULT,
    payload: result
})

export const smsSystemEditRequest = (data) => ({
    type: SMS_SYSTEM_EDIT_REQUEST,
    payload: data
})

export const smsSystemEditResult = (result) => ({
    type: SMS_SYSTEM_EDIT_RESULT,
    payload: result
})

export const smsSystemGetRequest = (data) => ({
    type: SMS_SYSTEM_GET_REQUEST,
    payload: data
})

export const smsSystemGetResult = (result) => ({
    type: SMS_SYSTEM_GET_RESULT,
    payload: result
})